import {
  InformationCircleIcon,
  CheckCircleIcon,
} from '@heroicons/react/24/outline'
import Tippy from '@tippyjs/react'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'

interface IProps {
  color: string
  itemKey: string
  components?: any[]
  explanationKey?: string
}
const CheckboxItem = ({
  color,
  itemKey,
  components,
  explanationKey,
}: IProps) => {
  const { t } = useTranslation('pricing')

  return (
    <div className='flex items-start justify-start gap-3 my-4 font-light'>
      <CheckCircleIcon className={`w-7 mr-1 shrink-0 ${color}`} />
      <div>
        <span className='mr-1'>
          {components ? (
            <Trans i18nKey={itemKey} components={components} />
          ) : (
            t(itemKey)
          )}
        </span>
        {explanationKey && (
          <Tippy
            content={<span>{t(explanationKey)}</span>}
            className='bg-gray-bg py-2 px-4 rounded-lg border-1 border-gray-400'
          >
            <InformationCircleIcon className='w-6 text-gray-300 align-text-bottom shrink-0' />
          </Tippy>
        )}
      </div>
    </div>
  )
}

export default CheckboxItem
